import { AuthService } from '$services/auth/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '$environments/environment'

@Component({
  selector: 'app-update-password',
  templateUrl: './update-password-page.component.html',
  styleUrls: ['./update-password-page.component.css'],
})
export class UpdatePasswordPageComponent implements OnInit {

  passwordResetForm: FormGroup;
  successMessage: string = '';
  errorMessage: string = '';
  token: string = '';
  email: string = '';

  constructor(private formBuilder: FormBuilder,
              private router: Router,
              private http: HttpClient,
              private activatedRoute: ActivatedRoute) {
      this.passwordResetForm = this.formBuilder.group({
        password: ['', [Validators.required, Validators.minLength(8)]],
        confirmPassword: ['', Validators.required]
      }, { validator: this.passwordMatchValidator });
    }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.token = params['token'];
      this.email = params['email'];
    });
  }

  onSubmit() {
      if (this.passwordResetForm.valid) {
        const formData = this.passwordResetForm.value;
        const { password } = formData;

        const resetPasswordRequest = {
          token: this.token,
          email: this.email,
          newPassword: password
        };

        this.http.post(environment.apiUrl + '/rest/reset-password', resetPasswordRequest)
          .subscribe(
            (response: any) => {
              this.successMessage = 'Mot de passe réinitialisé avec succès. Veuillez vous connecter avec votre nouveau mot de passe.';
              this.errorMessage = '';
            },
            (error: any) => {
              if (error.status === 400) {
                this.errorMessage = 'Token de réinitialisation invalide ou expiré.';
              } else {
                this.errorMessage = 'Une erreur s\'est produite lors de la réinitialisation du mot de passe. Veuillez réessayer plus tard.';
              }
              this.successMessage = '';
            }
          );
      }
    }

  passwordMatchValidator(formGroup: FormGroup) {
    const passwordControl = formGroup.get('password');
    const confirmPasswordControl = formGroup.get('confirmPassword');

    if (passwordControl && confirmPasswordControl) {
      const password = passwordControl.value;
      const confirmPassword = confirmPasswordControl.value;

      if (password !== confirmPassword) {
        confirmPasswordControl.setErrors({ passwordMismatch: true });
      } else {
        confirmPasswordControl.setErrors(null);
      }
    }
  }
}
